'use es6';
import getMomentToDateValue from './internal/getMomentToDateValue';
import getDateNumberFormattingLocale from './getDateNumberFormattingLocale';

export default (value, type) => {
  const dateValue = getMomentToDateValue(value, type);

  const dateFormatter = new Intl.DateTimeFormat(
    getDateNumberFormattingLocale(),
    { month: 'long', day: 'numeric' }
  );
  return dateFormatter.format(dateValue);
};
